export enum SpeakingRate {
  slow = "slow",
  normal = "normal",
  fast = "fast",
}
